import React from 'react';
import { Search, Loader2, ArrowUpRight } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { LocaleText } from '../../i18n/Locale';

export const SymbolSearch = ({ prefix, symbol, setSymbol, asset, setAsset, onSubmit, busy, label = 'Research', children, assetScope }) => (
  <form data-testid={`${prefix}-search-form`} onSubmit={onSubmit} className="research-search">
    <div className="symbol-input-wrap">
      <Search size={18} aria-hidden="true" />
      <Input data-testid={`${prefix}-symbol-input`} aria-label={assetScope === 'stock' ? 'Stock symbol' : assetScope === 'crypto' ? 'Cryptocurrency symbol' : 'Stock or cryptocurrency symbol'} autoComplete="off"
        placeholder={assetScope === 'stock' ? 'AAPL, NVDA, TSLA…' : assetScope === 'crypto' ? 'BTC, ETH, SOL…' : 'AAPL, NVDA, BTC…'} maxLength={20} value={symbol} disabled={busy}
        onChange={e => setSymbol(e.target.value.toUpperCase())} required />
    </div>
    <select data-testid={`${prefix}-asset-select`} aria-label="Asset type" value={assetScope || asset} disabled={busy || Boolean(assetScope)}
      onChange={e => setAsset(e.target.value)} className="research-select">
      {assetScope ? <option value={assetScope}>{assetScope === 'stock' ? 'US stocks / ETFs' : 'Crypto · USD'}</option> : <><option value="auto">All assets</option><option value="stock">US stocks / ETFs</option><option value="crypto">Crypto · USD</option></>}
    </select>
    {children}
    <Button data-testid={`${prefix}-search-button`} disabled={busy || !symbol.trim()} type="submit" className="research-primary">
      {busy ? <Loader2 className="animate-spin" size={16} /> : <ArrowUpRight size={16} />}<LocaleText value={label} />
    </Button>
  </form>
);